// Copyright (c) 2018 Comsearch, Inc., All rights reserved

import { push } from 'react-router-redux'
import { projectSummaryModalClose } from 'redux/modules/projectSummary'

// after a project is split, this is
// one of the actions the user can take
const goToNewProjectSummary = () => (dispatch, getState) => {
  const newProjectId = getState().projectSummary.get('modalMessage')
  dispatch(projectSummaryModalClose())
  dispatch(push(`/project-management/${newProjectId}`))
}

export default goToNewProjectSummary
